/* M&M IGLOO ATMOSPHERE JS — injects grain/fog, HUD tags, reveal engine. Idempotent. */
(function(){
  if(window.__mmIgloo) return; window.__mmIgloo = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }

  ready(function(){
    /* grain + fog overlays */
    if(!document.querySelector('.mm-grain')){
      var g=document.createElement('div'); g.className='mm-grain'; g.setAttribute('aria-hidden','true'); document.body.appendChild(g);
    }
    if(!document.querySelector('.mm-fog')){
      var f=document.createElement('div'); f.className='mm-fog'; f.setAttribute('aria-hidden','true'); f.innerHTML='<i></i><i></i>'; document.body.insertBefore(f, document.body.firstChild);
    }

    /* HUD tags + reveals on main content sections */
    var main=document.querySelector('main')||document.body;
    var sections=main.querySelectorAll('.shopify-section');
    var idx=1;
    sections.forEach(function(sec){
      var id=(sec.id||'').toLowerCase();
      /* skip header/footer/announcement/app/cleanup utility sections */
      if(/header|footer|announcement|cleanup|nav|polish|marquee/.test(id)) return;
      if(sec.offsetHeight < 120) return;
      if(!sec.classList.contains('mm-hud-host')){
        sec.classList.add('mm-hud-host');
        var tag=document.createElement('div');
        tag.className='mm-hud-tag';
        var label=id.replace(/shopify-section-|template--|__/g,' ').replace(/[^a-z0-9]+/g,'_').replace(/^_+|_+$/g,'').slice(0,28)||'section';
        tag.textContent='SEC_'+String(idx).padStart(2,'0')+' \u00B7 '+label.toUpperCase();
        sec.appendChild(tag);
      }
      if(!sec.hasAttribute('data-igloo-reveal')) sec.setAttribute('data-igloo-reveal','');
      idx++;
    });

    /* bracket hover on primary buttons */
    document.querySelectorAll('.button, button.button--primary, a.button').forEach(function(b){ b.classList.add('mm-brkt'); });

    /* reveal engine */
    if(reduced){ document.querySelectorAll('[data-igloo-reveal]').forEach(function(el){el.classList.add('igloo-in');}); return; }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('igloo-in'); io.unobserve(e.target);} });
    },{rootMargin:'0px 0px -8% 0px',threshold:0.05});
    document.querySelectorAll('[data-igloo-reveal]').forEach(function(el){
      var r=el.getBoundingClientRect();
      if(r.top < window.innerHeight*0.9){ el.classList.add('igloo-in'); } else { io.observe(el); }
    });
  });
})();
